import { defineStore } from 'pinia';
import { compositionAuthStore } from '@rready/security';

export const useAuthStore = defineStore('auth', compositionAuthStore);
